import { uuid } from '.'

export function isCsv (file: File): boolean {
  return /\.(xlsx|xls|csv)$/.test(file.name)
}

export function isFileType (file: File, fileTypes: string[]): boolean {
  return new RegExp(`.${fileTypes.join('|')}$`).test(file.name.toLowerCase())
}

export function downloadCanvas (canvasDataUrl: string | URL, fileName: string = uuid(), type = 'image/png') {
  const extension = type.split('/')[1] || 'png'
  const xhr = new XMLHttpRequest()
    xhr.responseType = 'blob'
    xhr.onload = function () {
        const a = document.createElement('a')
        a.href = window.URL.createObjectURL(xhr.response)
        a.download = `img_${fileName}.${extension}`
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click()
        a.remove()
      }
      xhr.open('GET', canvasDataUrl) // "download" the image dataurl
      xhr.send()
}
